<template>
  <div class="user-info-container">
    <div class="user-info-header">
      <div class="user-info-header-top">
        <div class="user-info-header-browse" @click="clickBrose">
          <div class="user-info-header-browse-text">
            {{ $t('view.popupInfo.browse') }}
          </div>
          <div>
            <van-icon name="more-o" size="20px" />
          </div>
        </div>
      </div>
      <div class="user-info-header-bottom">
        <div class="user-info-header-bottom-title">
          <div class="user-info-header-bottom-title-line">
            {{ $t('view.popupInfo.hello') }} {{ username }}
          </div>
        </div>
      </div>
    </div>
    <div class="user-info-profile">
      <div class="user-info-profile-card">
        <div class="user-info-profile-avatar">
          <van-image :src="avatar || require('@/assets/default_avatar.jpg')" lazy-load round width="34px" height="34px" />
        </div>
        <div class="user-info-profile-account">
          <div class="user-info-profile-account-name">
            {{ username }}
          </div>
          <div class="user-info-profile-account-email">
            {{ $t('view.popupInfo.uid') }}: {{ uid }}
          </div>
        </div>
      </div>
      <van-divider :style="{ color: '#d5dbdb', borderColor: '#d5dbdb', padding: '5px 19px', margin: '0px' }" />
      <div class="user-info-profile-set-account" @click="onNotification">
        <van-badge :content="notificationCount" max="99" v-if="notificationCount !== 0">
          <div>
            {{ $t('view.popupInfo.message') }}
          </div>
        </van-badge>
        <div v-else>
            {{ $t('view.popupInfo.message') }}
        </div>
      </div>
      <div class="user-info-profile-set-account" @click="onFavorite">
        {{ $t('view.popupInfo.favorite') }}
      </div>
      <div class="user-info-profile-set-account" @click="logout">
        {{ $t('view.popupInfo.logout') }}
      </div>
    </div>
    <div class="user-info-separator" />
    <div class="user-info-card">
      <div type="default" class="user-info-card-title-text user-info-card-title-padding">
        {{ $t('view.popupInfo.yourOrder') }}
      </div>
      <div class="user-info-card-item">
        <div class="user-info-card-item-text" @click="onYourOrder">{{ $t('view.popupInfo.manageOrder') }}</div>
      </div>

      <div class="user-info-card-item">
        <div class="user-info-card-item-text" @click="clickUserReview">{{ $t('view.popupInfo.review') }}</div>
      </div>
      <div class="user-info-card-item">
        <div class="user-info-card-item-text" @click="onFootprint">{{ $t('view.popupInfo.footprint') }}</div>
      </div>    </div>
    <div class="user-info-separator" />
    <div class="user-info-card">
      <div class="user-info-card-title-text user-info-card-title-padding">
        {{ $t('view.popupInfo.accountInfo') }}
      </div>
      <div class="user-info-card-item">
        <div class="user-info-card-item-text" @click="clickUserInfo">{{ $t('view.popupInfo.viewAccountInfo') }}</div>
      </div>
      <div class="user-info-card-item">
        <div class="user-info-card-item-text" @click="clickUserInfoEdit">{{ $t('view.popupInfo.manageAccount') }}</div>
      </div>
      <div class="user-info-card-item">
        <div class="user-info-card-item-text" @click="clickPasswordChange">{{ $t('view.popupInfo.changePassword') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import * as NotificationService from '@/services/NotificationService'
export default {
  name: 'PopupUserInfo',
  created() {
    this.getUserInfo()
  },
  data() {
    return {
      uid: sessionStorage.getItem('user_uid'),
      username: '',
      avatar: '',
      notificationCount: 0
    }
  },
  methods: {
    getUserInfo() {
      this.username = sessionStorage.getItem('user_nickname')
      this.avatar = this.$constants.IMAGE_BASEURL + sessionStorage.getItem('user_avatar')
      let data = {
        notificationReceiveUser: sessionStorage.getItem('user_id')
      }
      NotificationService.getNotificationCount(data).then((res)=>{
        this.notificationCount = parseInt(res)
      }).catch((error) => {
      }).finally(() => {
      })
    },
    clickBrose(menu) {
      this.$emit('click-brose', menu)
    },
    logout() {
      this.$emit('logout')
    },
    onYourOrder() {
      this.$emit('close-popup')
      if(this.$route.fullPath !== '/yourOrders'){
        this.$router.push('/yourOrders')
      }
    },
    onFootprint() {
      this.$emit('close-popup')
      if(this.$route.fullPath !== '/footPrint'){
        this.$router.push('/footPrint')
      }
    },
    onFavorite() {
      this.$emit('close-popup')
      if(this.$route.fullPath !== '/wantlist'){
        this.$router.push('/wantlist')
      }
    },
    clickUserInfo() {
      this.$emit('close-popup')
      if(this.$route.fullPath !== '/userInfo?UserInfoFlg=1'){
        this.$router.push('/userInfo?UserInfoFlg=1')
      }
    },
    clickUserInfoEdit() {
      this.$emit('close-popup')
      if(this.$route.fullPath !== '/userInfo?UserInfoFlg=2'){
        this.$router.push('/userInfo?UserInfoFlg=2')
      }
    },

    // 跳转修改密码
    clickPasswordChange() {   
      this.$emit('close-popup')
      if(this.$route.fullPath !== '/updatePwd'){
        this.$router.push('/updatePwd')
      }
    },
    clickUserReview() {   
      this.$emit('close-popup')
      if(this.$route.fullPath !== '/reviewManage'){
        this.$router.push('/reviewManage')
      }
    },
    onNotification() {
      this.$emit('close-popup')
      if(this.$route.fullPath !== '/notification'){
        this.$router.push('/notification')
      }
    }
  }
}
</script>

<style scoped>
.user-info {
  min-width: 20rem;
  padding: 12px 14px 28px;
  margin: 0 auto;
  max-width: 600px;
}
.user-info-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
}

.user-info-header {
  background-color: #232f3e;
  color: white;
  display: flex;
  flex-direction: column;
}

.user-info-header-top {
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.user-info-header-browse {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 20px 0 20px;
}

.user-info-header-browse-text {
  padding-right: 4px;
  font-size: 14px;
  line-height: 14px;
  color: #fff;
}

.user-info-header-bottom {
  flex-direction: column;
  justify-content: flex-end;
}

.user-info-header-bottom-title {
  flex-direction: column;
  justify-content: flex-end;
  color: #fff;
  padding: 0 20px 20px 20px;
}

.user-info-header-bottom-title-line {
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
}

.user-info-profile {
  padding: 38px 0px 15px 0px;
}

.user-info-profile-card {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  padding: 0px 26px;
}

.user-info-profile-avatar {
  margin-inline-end: 13px;
}

.user-info-profile-account {
  width: 100%;
  min-width: 0px;
}

.user-info-profile-account-name {
  width: 100%;
  font-size: 15px;
  font-weight: 600;
  padding: 2px 0px 2px 0px;
}

.user-info-profile-account-email {
  width: 100%;
  font-size: 13px;
  height: 15px;
  color: rgb(86, 89, 89);
  max-width: 150px;
  font-family: inherit;
}

.user-info-profile-set-account {
  font-size: 16px;
  padding: 15px 20px;
}

.user-info-separator {
  border-bottom: 5px solid #d5dbdb;
  padding: 0;
  margin: 5px 0 0;
  display: block;
}

.user-info-card {
  height: auto;
  transition: height .4s cubic-bezier(.4, 0, .2, 1), opacity .4s cubic-bezier(.4, 0, .6, 1);
  padding: 15px 20px 15px 20px;
}

.user-info-card-title-text {
  color: #111;
  font-size: 19px;
  line-height: 24px;
  font-weight: 700;
  text-transform: capitalize;
}

.user-info-card-title-padding {
  padding: 0px 0px 15px 0px;
}

.user-info-card-item-text {
  text-decoration: none;
  color: #111;
}

.user-info-card-item {
  display: flex;
  padding: 15px 0px 15px 0px;
  justify-content: space-between;
  cursor: pointer;
}
</style>